// extracted by mini-css-extract-plugin
export default {"input":"input-pass_input__uGuaD","input__outer":"input-pass_input__outer__R23lf"};